// extracted by mini-css-extract-plugin
module.exports = {"title":"Card_title__30phf"};